import React, { useState } from "react";
import {
  FaCheckCircle,
  FaPhoneAlt
} from "react-icons/fa";
import {
  MdCelebration,
  MdRestaurantMenu,
  MdEventAvailable
} from "react-icons/md";
import { HiArrowRight } from "react-icons/hi2";

const Banquet = () => {
  const [selectedPackage, setSelectedPackage] = useState("gold");

  const packages = [
    {
      id: "silver",
      name: "Silver Package",
      price: "₹1150",
      perPerson: "/per person",
      tag: null,
      features: [
        "2 WELCOME DRINK",
        "STARTERS (1 PANNER + 1 VEG.)",
        "1 SOUP",
        "2 SALAD",
        "ACHAR, PAPAD, CHUTNEY",
        "1 CURD PREPARATION",
        "1 PANEER",
        "1 SEASONAL VEGETABLE",
        "1 DAL",
        "1 RICE PREPARATION",
        "2 ASSORTED INDIAN BREAD",
        "2 DESSERTS INCLUDING ICE CREAM"
      ],
      color: "bg-gray-100",
      borderColor: "border-gray-300",
      textColor: "text-gray-800",
      accentColor: "bg-gray-600"
    },
    {
      id: "gold",
      name: "Gold Package",
      price: "₹1250",
      perPerson: "/per person",
      tag: "Most Popular",
      features: [
        "2 WELCOME DRINK",
        "3 STARTERS (1 PANEER + 2 VEG.)",
        "2 SOUPS (2 HOT)",
        "3 SALAD WITH 2 DRESSINGS",
        "ACHAR, PAPAD, CHUTNEY",
        "1 CURD PREPARATION",
        "1 PANEER",
        "1 SEASONAL VEGETABLE",
        "1 DELUXE VEGETABLE",
        "1 DAL",
        "1 RICE PREPARATION",
        "2 CHINESE PREPARATION",
        "3 ASSORTED INDIAN BREAD",
        "3 DESSERTS INCLUDING ICE CREAM"
      ],
      color: "bg-amber-50",
      borderColor: "border-amber-300",
      textColor: "text-amber-900",
      accentColor: "bg-amber-500"
    },
    {
      id: "platinum",
      name: "Platinum Package",
      price: "₹1350",
      perPerson: "/per person",
      tag: "Premium",
      features: [
        "2 WELCOME DRINK",
        "3 STARTERS (1 PANEER + 2 VEG.)",
        "3 SOUPS (2 HOT + 1 COLD)",
        "4 SALAD WITH 4 DRESSINGS",
        "ACHAR, PAPAD, CHUTNEY",
        "1 CURD PREPARATION",
        "2 PANEER",
        "2 SEASONAL VEGETABLE",
        "2 CHINESE PREPARATION",
        "1 DAL",
        "2 RICE PREPARATION",
        "1 PASTA",
        "4 ASSORTED INDIAN BREAD",
        "4 DESSERTS",
        "2 SWEET + 2 ICE-CREAM"
      ],
      color: "bg-blue-50",
      borderColor: "border-blue-300",
      textColor: "text-blue-900",
      accentColor: "bg-blue-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 py-12 px-4">
      {/* Header */}
      <div className="max-w-7xl mx-auto text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Banquet <span className="text-amber-600">Packages</span>
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Choose from our carefully curated packages
        </p>

        <button className="bg-gradient-to-r from-amber-500 to-amber-600 text-white py-3 px-8 rounded-lg shadow-lg hover:scale-105 transition flex items-center gap-2 mx-auto">
          Book Now
          <MdCelebration className="text-2xl" />
          <HiArrowRight />
        </button>
      </div>

      {/* Packages */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {packages.map((pkg) => (
          <div
            key={pkg.id}
            onClick={() => setSelectedPackage(pkg.id)}
            className={`rounded-2xl shadow-xl overflow-hidden cursor-pointer transition hover:-translate-y-2 ${
              selectedPackage === pkg.id ? "ring-2 ring-amber-500" : ""
            }`}
          >
            {/* Header */}
            <div className={`${pkg.color} ${pkg.borderColor} border-b p-6 relative`}>
              {pkg.tag && (
                <span className={`absolute top-4 right-4 ${pkg.accentColor} text-white text-xs px-3 py-1 rounded-full`}>
                  {pkg.tag}
                </span>
              )}

              <h3 className={`text-2xl font-bold text-center ${pkg.textColor}`}>
                {pkg.name}
              </h3>
              <p className="text-center mt-2">
                <span className={`text-4xl font-bold ${pkg.textColor}`}>
                  {pkg.price}
                </span>
                <span className="text-gray-600 ml-1">{pkg.perPerson}</span>
              </p>
            </div>

            {/* Features */}
            <div className="bg-white p-6">
              <ul className="space-y-3">
                {pkg.features.map((feature, i) => (
                  <li key={i} className="flex items-start">
                    <FaCheckCircle className={`mt-1 mr-3 ${pkg.textColor}`} />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <button className={`mt-8 w-full py-3 ${pkg.accentColor} text-white rounded-lg flex items-center justify-center gap-2`}>
                View Full Menu
                <MdRestaurantMenu />
              </button>
            </div>

            {/* Footer */}
            <div className={`${pkg.color} p-4 text-center`}>
              <button className={`${pkg.textColor} hover:underline`}>
                Customize this package
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Contact */}
      <div className="mt-16 text-center">
        <button className="bg-gradient-to-r from-green-500 to-green-600 text-white py-3 px-8 rounded-lg shadow-lg inline-flex items-center gap-2">
          Contact Event Manager
          <FaPhoneAlt />
        </button>
      </div>
    </div>
  );
};

export default Banquet;
